import { map } from 'rxjs';
import { IClientApiDependencySegment } from '@cbridge-packages/api';
import { IBaseSymbolsKey } from '../symbol.interface';

type IDependencies = IClientApiDependencySegment;

export interface IBaseSymbolsQueryParams extends IBaseSymbolsKey {
  limit: number;
  skip: number;
  isLastPage?: boolean;
}

export const fetchBaseSymbols = (
  queryParams: IBaseSymbolsQueryParams,
  dependencies: IDependencies,
) => {
  const { limit, skip, search } = queryParams;

  return dependencies.api.getSymbolList({
    limit,
    skip,
    search,
    excludeDetails: true,
  }).pipe(
    map(({ symbols }) => {
      const isLastPage = symbols.length < limit;
      const nextOffset = skip + limit;

      return {
        symbols,
        isLastPage,
        limit,
        skip: nextOffset,
        search,
      };
    }),
  );
};
